import React from "react";
import { PATH_FAQ } from "../utils/constants";
import { FAQSection } from "../components/common/FAQSection";
import { FAQData } from "../types/faq";
import faqs from "../data/faqs.json";
import { SEOHelmet } from "../components/common/SEOHelmet";

export default function FAQsPage() {
  const faqData = faqs as FAQData;

  return (
    <>
      <SEOHelmet page="faqs" pathname={PATH_FAQ} />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqData.faqs.flatMap((category) =>
            category.items.map((item) => ({
              "@type": "Question",
              "name": item.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer.replace(/<[^>]*>/g, '')  // Strip HTML tags for plain text
              }
            }))
          )
        })}
      </script>
      <div className="relative isolate overflow-hidden">
        <FAQSection faqs={faqData.faqs} />
      </div>
    </>
  );
}
